import { ApiSchemas } from '..'
import { client } from '../client'
import { wrapEndpoint } from '../wrap'

export default {
  async verify(uuid: string) {
    return wrapEndpoint(() =>
      client.GET('/attendance-share-token/{uuid}/verify', {
        params: {
          path: {
            uuid,
          },
        },
      }),
    )
  },

  async create(body: ApiSchemas['CreateAttendanceShareTokenDto']) {
    return wrapEndpoint(() => client.POST('/attendance-share-token', { body }))
  },

  async delete(uuid: string) {
    await wrapEndpoint(() =>
      client.DELETE('/attendance-share-token/{uuid}', {
        params: {
          path: {
            uuid,
          },
        },
      }),
    )
  },

  async use() {
    await wrapEndpoint(() => client.PATCH('/attendance-share-token/use'))
  },
}
